import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CardComponent from "../CardComponent/CardComponent";
import { ICONS } from "../../constants/constants"; // Import IMAGES from constants.js
import { COLORS } from "../../constants/constants"; // Import COLORS from constants.js
import "./DashboardCards.css";
import { useSelector } from "react-redux";

const DashboardCards = ({ cardData }) => {

  return (
    <Container className="dashboard-cards">
      <Row>
        {cardData && cardData.length > 0 ? (
          cardData.map((data, index) => (
            <Col md={3} key={index}>
              <CardComponent
                title={data.title}
                value={data.value}
                bgColor={COLORS[data.colorKey]}
                image={ICONS[data.imageKey]}
              />
            </Col>
          ))
        ) : (
          <div>No data available</div>
        )}
      </Row>
    </Container>
  );
};

export default DashboardCards;
